export default "__VITE_ASSET__BI2ZG9I6__"